import styled from 'styled-components'

const darkColor = props => props.theme.global.colors['dark-2']
const lightColor = props => props.theme.global.colors['white']
const borderColor = props => props.theme.global.colors['light-7']
const pageWidth = props => props.theme.global.size.pageWidth
const lineColor = "#939398"

export const Container = styled.div`
  max-width: ${pageWidth};
  width: 100%;
  margin: 0 auto 24px;
  padding: 0 40px;
  box-sizing: border-box;

  @media only screen and (max-width: 992px) {
    padding: 0 16px;
  }
`

export const Heading = styled.h1`
  color: ${darkColor};
  font-size: 24px;
  font-weight: 500;
  line-height: 150%;
  margin: 0 0 24px;

  @media only screen and (max-width: 992px) {
    font-size: 20px;
    margin-bottom: 16px;
  }
`

export const ReturnDetailsBox = styled.div`
  padding: 24px;
  border-radius: 4px;
  border: 1px solid ${borderColor};
  background-color: ${lightColor};

  @media only screen and (max-width: 768px) {
    padding: 16px;
  }
`


export const OrderInfo = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
  margin-bottom: 24px;

  @media screen and (max-width: 485px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const VerticalLine = styled.p`
  font-size: 16px;
  font-weight: 600;
  color: ${lineColor};
  margin: 0;

  @media screen and (max-width: 992px) {
    display: none;
  }
`

export const InfoText = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: ${darkColor};
  margin: 0;

  span {
    font-size: 16px;
    font-weight: 600;
    color: ${darkColor};
    margin: 0;

    @media screen and (max-width: 992px) {
      font-size: 14px;
    }
  }

  @media screen and (max-width: 992px) {
    font-size: 14px;
  }
`